import { PayloadAction } from '@reduxjs/toolkit';
import { SyfoAppState } from '../state';
import { LiabilityNode } from '@syfo/types/vault.types';
import { updateById } from './reducer-utils';

export const addLiability = (state: SyfoAppState, action: PayloadAction<LiabilityNode>) => {
  if (state.currentVault) {
    state.currentVault.data.liabilities.push(action.payload);
  }
};

export const updateLiability = (state: SyfoAppState, action: PayloadAction<{ id: string; liability: Partial<LiabilityNode> }>) => {
  if (state.currentVault) {
    updateById(state.currentVault.data.liabilities, action.payload.id, action.payload.liability);
  }
};

export const removeLiability = (state: SyfoAppState, action: PayloadAction<string>) => {
  if (state.currentVault) {
    state.currentVault.data.liabilities = state.currentVault.data.liabilities.filter(l => l.id !== action.payload);
  }
};
